import HTTPClient from '../..'
import { Member, UpsertMember } from '@services/nomos_api/entities/user'

export const createUserAPI = async (member: UpsertMember) => {
  const { data } = await HTTPClient.post('users', member)
  return data as Member
}
